export default __webpack_public_path__ + "static/media/logoPayID64.784de4e6.svg";